/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceBody } from '../models/DeviceBody';
import type { EventBody } from '../models/EventBody';
import type { ScanBody } from '../models/ScanBody';
import type { ScanUploadComplete } from '../models/ScanUploadComplete';
import type { ScanUploadRequest } from '../models/ScanUploadRequest';
import type { ScanUploadURL } from '../models/ScanUploadURL';
import type { TelemetryEntity } from '../models/TelemetryEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AgentService {
    /**
     * Get Manifest
     * Return manifest file
     * @param groupId
     * @returns string Manifest file returned successfully.
     * @throws ApiError
     */
    public static agentControllerGetManifest(
        groupId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/agent/telemetry/{groupID}/getManifest',
            path: {
                'groupID': groupId,
            },
            errors: {
                404: `Manifest file not found.`,
                422: `Provided data is incorrect.`,
                500: `Error while communicating with database.`,
            },
        });
    }
    /**
     * send information about scan
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    public static agentControllerPostScan(
        requestBody: ScanBody,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/agent/telemetry/scans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Request forbidden`,
                404: `There is no device with provided fingerprint.`,
                409: `scan with provided GUID already exist in DB`,
                422: `Unprocessable entity`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * send data about event
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    public static agentControllerPostEvent(
        requestBody: EventBody,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/agent/telemetry/events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Request forbidden`,
                404: `Event not found`,
                409: `event with provided GUID already exist in DB`,
                422: `Unprocessable entity`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * send information about device
     * Devices are distinguished by the 'fingerprint' field.
     * If a device with the fingerprint already exists, it gets replaced.
     * Every replace creates a record in History Collection.
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    public static agentControllerPutDevice(
        requestBody: DeviceBody,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/agent/telemetry/devices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Request forbidden`,
                404: `Device with given fingerprint not found`,
                422: `Unprocessable entity`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Query all current telemetry entities in the database.
     * Query all current telemetry entities in the database.
     * @returns TelemetryEntity The list of the requested telemetry entities.
     * @throws ApiError
     */
    public static agentControllerGetTelemetryEntities(): CancelablePromise<Array<TelemetryEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/agent/telemetry/entities/get',
        });
    }
    /**
     * Create Upload URL to upload your scan
     * Create Upload URL to upload your scan
     * @param requestBody
     * @returns ScanUploadURL Upload URL created successfully.
     * @throws ApiError
     */
    public static agentControllerCreateScanUploadUrl(
        requestBody: ScanUploadRequest,
    ): CancelablePromise<ScanUploadURL> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/agent/scans/file/upload_url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed syntax of request body.`,
                403: `User is not allowed to make this request.`,
                404: `Not found.`,
                412: `Two or more owner types are duplicated.`,
                422: `Unprocessable Entity.`,
                500: `Internal server error.`,
            },
        });
    }
    /**
     * Finish scan upload, mark scan meta as completed.
     * Finish scan upload and mark scan meta as completed.
     * @param measurementId
     * @returns ScanUploadComplete
     * @throws ApiError
     */
    public static agentControllerCompleteScanUpload(
        measurementId: string,
    ): CancelablePromise<ScanUploadComplete> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/agent/scans/file/{measurementID}/complete_upload',
            path: {
                'measurementID': measurementId,
            },
            errors: {
                403: `User is not allowed to make this request.`,
                404: `When the given measurement ID is not registered in a session.`,
                409: `Scan was already completed.`,
                412: `Precondition Failed, file was not uploaded.`,
                422: `Unprocessable Entity.`,
                500: `Internal server error.`,
            },
        });
    }
}
